import { render, staticRenderFns } from "./TrailerEdit.vue?vue&type=template&id=1f4caacc&"
import script from "./TrailerEdit.vue?vue&type=script&lang=js&"
export * from "./TrailerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports